import { ROUTE_CODES } from "@/routes/route-codes";

export const ModulesCodes = {
  SUPPORT_PLAN_DASHBOARD: "SUPPORT_PLAN_DASHBOARD",
  SUPPORT_PLAN: "SUPPORT_PLAN",
  CLIENT_SUPPORT_PLAN: "CLIENT_SUPPORT_PLAN",
  ASSIGNED_CLIENT: "ASSIGNED_CLIENT",
  SUPPORT_CIRCLE: "SUPPORT_CIRCLE",
  CS_REPRESENTATIVE: "CS_REPRESENTATIVE",
  EMERGENCY_PLANNING: "EMERGENCY_PLANNING",
  PERSONAL_SUPPORT_DETAILS: "PERSONAL_SUPPORT_DETAILS",
  CARE_PLAN_ACTIONS: "CARE_PLAN_ACTIONS",
  CARE_PLAN_CALENDER: "CARE_PLAN_CALENDER",
  CALENDER_HEAT_MAP: "CALENDER_HEAT_MAP",
  TECHNOLOGY_DETAILS: "TECHNOLOGY_DETAILS",
  ALERT_CONDITIONS: "ALERT_CONDITIONS",
  HEALTH_INFORMATION: "HEALTH_INFORMATION",
  GENERATE_DOCUMENT: "GENERATE_DOCUMENT",
  SUSPENSION_HISTORY: "SUSPENSION_HISTORY",
  SUPPORT_PLAN_ACKNOWLEDGEMENT_HISTORY: "SUPPORT_PLAN_ACKNOWLEDGEMENT_HISTORY",
  SUPPORT_PLAN_INDIVIDUAL_VERSION_HISTORY:
    "SUPPORT_PLAN_INDIVIDUAL_VERSION_HISTORY",
  SATISFACTION_SCORES: "SATISFACTION_SCORES",
  INDIVIDUAL_COMMUNICATIONS_REPORT: "INDIVIDUAL_COMMUNICATIONS_REPORT",
  BILLING_HISTORY: "BILLING_HISTORY",
  SUSPENSION_MANAGER: "SUSPENSION_MANAGER",
  BTN_ADD_NEW_SUSPENSION: "BTN_ADD_NEW_SUSPENSION",
  BTN_CLEAN_UP_REMOVAL_QUEUE: "BTN_CLEAN_UP_REMOVAL_QUEUE",
  FS_TOOLS: "FS_TOOLS",
  GEOCOMM_UTILITIES: "GEOCOMM_UTILITIES",
  GEOCOMM_MAINTENANCE: "GEOCOMM_MAINTENANCE",
  GEOCOMM_WRISTBAND: "GEOCOMM_WRISTBAND",
  PROVISION_GEOCOMM_DEVICE: "PROVISION_GEOCOMM_DEVICE",
  WRISTBAND_CONTACTS: "WRISTBAND_CONTACTS",
  WRISTBAND_GEOFENCE: "WRISTBAND_GEOFENCE",
  GENERATE_SHORT_TOKEN: "GENERATE_SHORT_TOKEN",
  REBOOT_WRISTBAND: "REBOOT_WRISTBAND",
  SHINOBI_CAMERA: "SHINOBI_CAMERA",
  SHINOBI_CAMERA_CONFIG: "SHINOBI_CAMERA_CONFIG",
  SUPPORT_CENTER_TABS: "SUPPORT_CENTER_TABS",
  FOSCAM_CAMERA: "FOSCAM_CAMERA",
  FOSCAM_CAMERA_CONFIG: "FOSCAM_CAMERA_CONFIG",
  IGUARD_STOVE: "IGUARD_STOVE",
  PROVISION_IGUARD_DEVICE: "PROVISION_IGUARD_DEVICE",
  SENSOR_SYSTEM_UTILITIES: "SENSOR_SYSTEM_UTILITIES",
  PROVISION_SENSOR_SYSTEM: "PROVISION_SENSOR_SYSTEM",
  SENSOR_STATUS_TOOLS: "SENSOR_STATUS_TOOLS",
  SENSOR_SYSTEM_MESSAGE_STATUS: "SENSOR_SYSTEM_MESSAGE_STATUS",
  SENSOR_OUTAGE_STATUS: "SENSOR_OUTAGE_STATUS",
  IUS_SENSOR_STATUS: "IUS_SENSOR_STATUS",
  TABLET_DASHBOARD: "TABLET_DASHBOARD",
  BATTERY_LEVEL: "BATTERY_LEVEL",
  DEVICE_GRID: "DEVICE_GRID",
  TABLET_UTILITIES: "TABLET_UTILITIES",
  TABLET_MAINTENANCE: "TABLET_MAINTENANCE",
  BILLING_TOOLS: "BILLING_TOOLS",
  EMBS_FILE_MANAGEMENT: "EMBS_FILE_MANAGEMENT",
  UPLOAD_WEEKLY_EMBS_FILE: "UPLOAD_WEEKLY_EMBS_FILE",
  EMBS_CLIENT_MANAGEMENT: "EMBS_CLIENT_MANAGEMENT",
  EDIT_BILLING_PARAMETERS: "EDIT_BILLING_PARAMETERS",
  BILLING_DATA: "BILLING_DATA",
  BILLING_WEEK_SUMMARY: "BILLING_WEEK_SUMMARY",
  SENSOR_MANAGER: "SENSOR_MANAGER",
  SETTINGS: "SETTINGS",
  APPLICATION_SETTINGS: "APPLICATION_SETTINGS",
  SPECIAL_HANDLING_MANAGER: "SPECIAL_HANDLING_MANAGER",
  GLOBAL_ANNOUNCEMENTS: "GLOBAL_ANNOUNCEMENTS",
  COMMUNICATION_METHODS: "COMMUNICATION_METHODS",
  USER_ADMINISTRATION: "USER_ADMINISTRATION",
  USER_ADMINISTRATION_MAINTENANCE: "USER_ADMINISTRATION_MAINTENANCE",
  SSO_ASSOCIATION_MAINTENANCE: "SSO_ASSOCIATION_MAINTENANCE",
  APPLICATION_ADMINISTRATION: "APPLICATION_ADMINISTRATION",
  USER_RIGHTS_MAINTENANCE: "USER_RIGHTS_MAINTENANCE",
  USER_ROLES_MAINTENANCE: "USER_ROLES_MAINTENANCE",
  SYSTEM_TAG_MAINTENANCE: "SYSTEM_TAG_MAINTENANCE",
  TABLET_NOTIFICATION_CONFIGURATION: "TABLET_NOTIFICATION_CONFIGURATION",
  APPLICATION_LOGS: "APPLICATION_LOGS",
  SUPPORT_PLAN_LOGS: "SUPPORT_PLAN_LOGS",
  QOL_ADMINISTRATION: "QOL_ADMINISTRATION",
  QOL_MAINTENANCE: "QOL_MAINTENANCE",
  ANSWER_MAINTENANCE: "ANSWER_MAINTENANCE",
  OBJ_ADMINISTRATION: "OBJ_ADMINISTRATION",
  OBJECTIVES_MAINTENANCE: "OBJECTIVES_MAINTENANCE",
  CHECKLIST_ADMIN: "CHECKLIST_ADMIN",
  CHECKLIST_MAINTENANCE: "CHECKLIST_MAINTENANCE",
  FIVE9_ADMIN: "FIVE9_ADMIN",
  UNVERIFIED_NUMBER_MAINTENANCE: "UNVERIFIED_NUMBER_MAINTENANCE",
  DASHBOARD_ADMIN: "DASHBOARD_ADMIN",
  DASHBOARD_PAGE_MAINTENANCE: "DASHBOARD_PAGE_MAINTENANCE",
  DASHBOARD_FUNCTION_MAINTENANCE: "DASHBOARD_FUNCTION_MAINTENANCE",
  DASHBOARD_FUNCTION_PARAMS_OPTIONS: "DASHBOARD_FUNCTION_PARAMS_OPTIONS",
  DASHBOARD_OBJECT_TYPES: "DASHBOARD_OBJECT_TYPES",
  DASHBOARD_PAGE_OBJECTS: "DASHBOARD_PAGE_OBJECTS",
  DASHBOARD_PAGE_BUILDER: "DASHBOARD_PAGE_BUILDER",
  SENTIMENT_ADMIN: "SENTIMENT_ADMIN",
  SENTIMENT_MAINTENANCE: "SENTIMENT_MAINTENANCE",
  IUS_SENSOR: "IUS_SENSOR",
  AUTH_FROM_TOKEN: "AUTH_FROM_TOKEN",
  CALENDAR_VIEWER: "CALENDAR_VIEWER",
  ...ROUTE_CODES,
};

export const CarePlanUsersAddSearch = {
  CaseManager: "CASE_MANAGERS",
  Guardian: "GUARDIANS",
  HPC: "HPC",
  NaturalSupport: "NATURAL_SUPPORT",
  CallTree: "CALL_TREE",
  CSR: "CSR",
  EmergencyPlan: "EMERGENCY_CONTACT",
};

export const CarePlanUsersAssociate = {
  CaseManager: "CP_CASE_MANAGERS",
  Guardian: "CP_GUARDIANS",
  HPC: "CP_HPC",
  NaturalSupport: "CP_NATURAL_SUPPORT",
  CallTree: "CP_CALL_TREE",
  CSR: "CSR_CLIENTS",
  EmergencyPlan: "CP_EMERGENCY_CONTACT",
};

export const CarePlanUsersStoreTypes = {
  CaseManager: "manager",
  Guardian: "guardian",
  HPC: "provider",
  NaturalSupport: "naturalSupport",
  CallTree: "callTree",
  CSR: "csr",
  EmergencyPlan: "emergencyPlan",
};

export const CarePlanUsersTypes = {
  CaseManager: "Case Manager",
  Guardian: "Guardian",
  HPC: "Provider",
  NaturalSupport: "Natural Support",
  CallTree: "Call Tree",
  CSR: "Client Services Representative",
  EmergencyPlan: "Emergency Plan Contact",
};

export const CareCircleRelationShipTypes = [
  { value: "CP_MOTHER", label: "Mother" },
  { value: "CP_FATHER", label: "Father" },
  { value: "CP_FRIEND", label: "Friend" },
  { value: "CP_AUNT", label: "Aunt" },
  { value: "CP_SISTER", label: "Sister" },
  { value: "CP_BROTHER", label: "Brother" },
  { value: "CP_UNCLE", label: "Uncle" },
  { value: "CP_NEIGHBOR", label: "Neighbor" },
  { value: "CP_CASE_MANAGER", label: "Case Manager" },
  { value: "CP_PROVIDER", label: "Provider" },
  { value: "CP_OTHER_RELATIVE", label: "Other Relative" },
  { value: "CP_OTHER", label: "Other" },
];

export const CareCircleUserPhoneTypes = [
  { value: "CELL", label: "Mobile" },
  { value: "HOME", label: "Home" },
  { value: "OFFICE", label: "Office" },
  { value: "GEOCOMM", label: "GeoComm" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "OTHER", label: "Other" },
];

export const SensorCapabilityOperators = [
  { value: "EQUAL_TO", operator: "==", label: "Equal to" },
  { value: "NOT_EQUAL_TO", operator: "!=", label: "Not equal To" },
  { value: "LESS_THAN", operator: "<", label: "Less Than" },
  { value: "GREATER_THAN", operator: ">", label: "Greater than" },
  { value: "LESS_THAN_OR_EQUAL", operator: "<=", label: "Less Than or equal" },
  {
    value: "GREATER_THAN_OR_EQUAL",
    operator: ">=",
    label: "Greater than or equal",
  },
];

export const CopyGroupDataFieldsName = {
  cpEmergencyContact: "CP_EMERGENCY_CONTACT",
  disasterEmergencyPlan: "DISASTER_EMERGENCY_PLAN",
  csrClients: "CSR_CLIENTS",
  ddBoard: "DD_BOARD",
};

export const CopyGroupDataFields = [
  {
    value: CopyGroupDataFieldsName.cpEmergencyContact,
    label: "Existing Emergency Contact(s)",
  },
  {
    value: CopyGroupDataFieldsName.disasterEmergencyPlan,
    label: "Disaster and Emergency Plan",
  },
  {
    value: CopyGroupDataFieldsName.csrClients,
    label: "Assigned Client Service Representative(s)",
  },
  { value: CopyGroupDataFieldsName.ddBoard, label: "DD BOARD" },
];

export const EMBS_Reports_Codes = {
  EMBS_Bill_Insert: "EMBS_Bill_Insert",
  EMBS_Error_Insert: "EMBS_Error_Insert",
  EMBS_Approved_Insert: "EMBS_Approved_Insert",
  EMBS_Denied_Insert: "EMBS_Denied_Insert",
  EMBS_Invoice_Insert: "EMBS_Invoice_Insert",
  EMBS_Submitted_Insert: "EMBS_Submitted_Insert",
};

export const EMBS_Reports = [
  { value: EMBS_Reports_Codes.EMBS_Bill_Insert, label: "Billing Report" },
  { value: EMBS_Reports_Codes.EMBS_Error_Insert, label: "Error Report" },
  { value: EMBS_Reports_Codes.EMBS_Approved_Insert, label: "Approve Report" },
  { value: EMBS_Reports_Codes.EMBS_Denied_Insert, label: "Deny Report" },
  { value: EMBS_Reports_Codes.EMBS_Invoice_Insert, label: "Invoice Report" },
  {
    value: EMBS_Reports_Codes.EMBS_Submitted_Insert,
    label: "Supplementary Submission Report",
  },
];

export const EMBSReportFile = [
  { id: EMBS_Reports_Codes.EMBS_Bill_Insert, nameIncludes: "BILL_FLAT" },
  { id: EMBS_Reports_Codes.EMBS_Error_Insert, nameIncludes: "ERROR_FLAT" },
  {
    id: EMBS_Reports_Codes.EMBS_Approved_Insert,
    nameIncludes: "REIMB_FLATAPPV",
  },
  { id: EMBS_Reports_Codes.EMBS_Denied_Insert, nameIncludes: "REIMB_FLATDENY" },
  { id: EMBS_Reports_Codes.EMBS_Invoice_Insert, nameIncludes: "INVCFLAT" },
  { id: EMBS_Reports_Codes.EMBS_Submitted_Insert, nameIncludes: "m990324904" },
];

export const EmergencyTypes = [
  { id: 1, code: "police", name: "Police" },
  { id: 2, code: "fire", name: "Fire" },
  { id: 3, code: "medical", name: "Medical" },
  { id: 4, code: "generalDispatch", name: "General Dispatch" },
];

export const FieldTypes = {
  link: {
    muiLink: "muiLink",
  },
  name: {
    name: "name",
    nameFirst: "nameFirst",
    nameLast: "nameLast",
    organization: "organization",
    contactComment: "contactComment",
    visitorName: "visitorName",
    newGroup: "newGroup",
  },
  email: {
    email: "email",
    muiEmail: "muiEmail",
  },
  phone: {
    phone: "phone",
    phoneNumber: "phoneNumber",
    secondaryPhoneNumber: "secondaryPhoneNumber",
    phoneNo1: "phoneNo1",
    phoneNo2: "phoneNo2",
    countyPhone: "countyPhone",
    countyOnCall: "countyOnCall",
    muiPhone: "muiPhone",
    protectedService: "protectedService",
    newCountyPhone: "newCountyPhone",
    newCountyOnCall: "newCountyOnCall",
    ddBoardCountyPhone: "ddBoardCountyPhone",
    ddBoardCountyOnCall: "ddBoardCountyOnCall",
  },
  phoneType: {
    secondaryPhoneUseCode: "secondaryPhoneUseCode",
    phoneType1: "phoneType1",
    phoneType2: "phoneType2",
  },
  phoneUseCode: "phoneUseCode",
  numeric: "numeric",
  relationshipType: "relationshipTypeCode",
};

export const ExternalLinks = {
  forgotUsername: "https://beta.safeinhome.com/forgotusername",
  forgotPassword: "https://beta.safeinhome.com/forgotpassword",
};

export const CalenderRecurrence = {
  DayOfWeek: "DAY_OF_WEEK",
  DayOfMonth: "DAY_OF_MONTH",
  Periodic: "PERIODIC",
  WeekOfMonth: [
    "FIRST_OF_MONTH",
    "SECOND_OF_MONTH",
    "THIRD_OF_MONTH",
    "FOURTH_OF_MONTH",
  ],
};

export const CalendarWeekDaysTypes = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const BooleanValues = [
  "true",
  "True",
  "TRUE",
  "false",
  "False",
  "FALSE",
];

export const EMBS_User_Service_Codes = [
  { value: "RS", label: "RS" },
  { value: "AT", label: "AT" },
];

export const weekNames = [
  { label: "A", value: "a" },
  { label: "B", value: "b" },
  { label: "C", value: "c" },
  { label: "D", value: "d" },
];

// support plan individual version history field names
export const IndividualVersionHistoryFields = {
  "CP CASE MANAGERS": "Case Manager",
  "CP Call Tree": "Call Tree",
  "CP EMERGENCY CONTACT": "Emergency Contact",
  "CP Guardian": "Guardian Information",
  "CP HPC": "Provider Information",
  "CP Natrual Support": "Natural Support",
  "CSR Client": "Client Services Representative",
  ClientComment: "Assigned Client Note",
  DdboardId: "DD Board",
  Visitor: "Visitor",
  Diagnosis: "Diagnoses",
  Allergies: "Allergies",
  DisasterDetails: "Disaster and Emergency Plan",
  PersonalDetails: "Personal Details",
  TechnologyDetails: "Technology Details",
  SupportDetails: "Support Details",
  CriticalClientInformation: "Critical Information",
  WhatToCareNoteFor: "Include the following in your Support Note",
};

// Gateway Types for Sensor Management
export const gatewayTypeCode = {
  SmartThings: "SMART_THINGS",
  HomeAssistant: "HOME_ASSISTANT",
  All: "ALL",
};

// User Types for Sensor Management Provisioned and Un-Provisioned Users
export const gatewayUserTypes = {
  All: "ALL",
  Provisioned: "PROVISIONED",
  UnProvisioned: "UN_PROVISIONED",
};

export const updateSectionnotes = {
  caseManagerNotes: "CaseManagerNotes",
  emergencyNotes: "EmergencyNotes",
  ddBoardNotes: "DdBoardNotes",
  allergyNotes: "AllergyNotes",
  diagnosisNotes: "DiagnosisNotes",
  technologyNotes: "TechnologyNotes",
  callTreeNotes: "CallTreeNotes",
};

export const sensorTypeCodes = {
  "Bed Presence": "BED_PRESENCE",
  "Ecolink Z-Wave Door/Window Sensor": "ECOLINK_Z-WAVE_DOOR/WINDOW_SENSOR",
  "Exit Door": "EXIT_DOOR",
};

export const DoorSensorTypes = [
  { value: "Bed Presence", label: "Bed Presence" },
  {
    value: "Ecolink Z-Wave Door/Window Sensor",
    label: "Ecolink Z-Wave Door/Window Sensor",
  },
  { value: "Exit Door", label: "Exit Door" },
];

export const logTypes = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  ALL: "ALL",
};

export const initialProvisionedCLientsSearchQuery = {
  gatewayUserType: gatewayUserTypes.All,
  gatewayType: gatewayTypeCode.All,
  sihAccId: "",
  nameFirst: "",
  nameLast: "",
  pageNumber: 0,
  pageSize: 10,
};

export const initialLogListingSearchQuery = {
  sensorExternalId: "",
  sensorName: "",
  logType: logTypes.ALL,
  pageNumber: 0,
  pageSize: 10,
};

export const initialSensorListingQuery = {
  pageNumber: 0,
  pageSize: 10,
};

// Log Type Codes
export const logTypeCodes = {
  S_SENSOR_CAPABILITY_CHANGE: "S_SENSOR_CAPABILITY_CHANGE",
};

export const supportPlanClientsExcelColumns = [
  {
    key: "name",
    header: "Name",
    width: 30,
  },
  {
    key: "address",
    header: "Address",
    width: 30,
  },
  {
    key: "city",
    header: "City",
    width: 15,
  },
  {
    key: "state",
    header: "State",
    width: 15,
  },
  {
    key: "sihAccId",
    header: "SIH ACC ID",
    width: 20,
  },
  {
    key: "caseManagers",
    header: "Case Managers",
    width: 30,
  },
  {
    key: "csReps",
    header: "CS Reps",
    width: 30,
  },
  {
    key: "serviceType",
    header: "Service Type",
    width: 20,
  },
];

export const supportPlanClientsRsAgentsCol = [
  {
    key: "rsAgentNames",
    header: "RS Agent Names",
    width: 30,
  },
];

// Dashboard Administration
export const dashboardPageObjectsColumns = [
  { id: "objectName", label: "Object Name", minWidth: 150, align: "center" },
  {
    id: "objectType",
    label: "Object Type",
    minWidth: 50,
    align: "center",
  },
  {
    id: "function",
    label: "Function",
    minWidth: 50,
    align: "center",
  },
  {
    id: "alignment",
    label: "Alignment",
    minWidth: 50,
    align: "center",
  },
  {
    id: "order",
    label: "Order",
    minWidth: 50,
    align: "center",
  },
  {
    id: "displayTitle",
    label: "Display Title",
    minWidth: 50,
    align: "center",
  },
  { id: "action", label: "Action", minWidth: 150, align: "center" },
];

export const alignment = [
  { label: "Full Column", value: "Full Column" },
  { label: "Left Side", value: "Left Side" },
  { label: "Center", value: "Center" },
  { label: "Right Side", value: "Right Side" },
];

export const dashboardRefreshOptions = {
  1: "Never",
  2: "2 min",
  5: "5 min",
  15: "15 min",
  30: "30 min",
  60: "1 hour",
};

export const US_TIMEZONES = [
  {
    label: "Pacific Time",
    code: "America/Los_Angeles",
    value: "Pacific Standard Time",
  },
  {
    label: "Mountain Time",
    code: "America/Denver",
    value: "Mountain Standard Time",
  },
  {
    label: "Mountain (Arizona)",
    code: "America/Phoenix",
    value: "US Mountain Standard Time",
  },
  {
    label: "Central Time",
    code: "America/Chicago",
    value: "Central Standard Time",
  },
  {
    label: "Eastern Time",
    code: "America/New_York",
    value: "Eastern Standard Time",
  },
];
